var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topNav"},[_c('van-sticky',[(_vm.isShow)?_c('van-nav-bar',{style:({
        background: _vm.bgColor,
        color: _vm.textColor,
        '--txtcolor': _vm.textColor,
      }),attrs:{"title":_vm.title,"right-text":_vm.rightText,"left-arrow":""},on:{"click-left":_vm.onClickLeft,"click-right":function($event){return _vm.onClickRight(_vm.rightHref)}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }